import type { CopyShape } from "@tami/core/intl";

import type { WHATSAPP_SCRIPT_COPY_PT_BR } from "../whatsapp-script.copy";

export const WHATSAPP_SCRIPT_COPY_ES_ES: CopyShape<typeof WHATSAPP_SCRIPT_COPY_PT_BR> = {
  whatsappIntro: {
    narrative:
      "Tãmi vive en tu WhatsApp: te organiza el día, agenda contenido y sigue tus números — todo en la conversación.",
  },
  whatsappAgenda: {
    narrative:
      "Cada mañana, Tãmi te manda la agenda lista: publicaciones, eventos y vencimientos del día en un solo sitio.",
    callout: "Buenos días con la agenda a mano — enviada automáticamente, sin que tengas que pedirla.",
  },
  whatsappContent: {
    narrative: "¿Se te ha ocurrido algo? Mándalo por WhatsApp. Tãmi crea la planificación en el Centro de contenido al momento.",
    callout: "Tú lo describes, Tãmi lo planifica: red, formato y fecha ya registrados.",
  },
  whatsappEvent: {
    narrative: "¿Tienes que cuadrar una grabación o una reunión? Te la añade directamente a la agenda y te lo recuerda ese día.",
    callout: "Eventos del calendario creados desde la conversación, con recordatorio garantizado.",
  },
  whatsappPerformance: {
    narrative:
      "Y al final de la semana llega el resumen de rendimiento: engagement, posts y seguidores, comparados con la semana anterior.",
    callout: "Resumen semanal automático — tus números llegan masticaditos a WhatsApp.",
  },
  whatsappOutro: {
    narrative: "De la agenda de la mañana al resumen de la semana: Tãmi se encarga de la rutina mientras tú te centras en crear.",
  },
};
